import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Dialog,
  DialogContent,
  Menu,
  MenuItem,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tooltip,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Icons, Images } from "assets";
import classNames from "classnames";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MultiAxisLineChart from "shared/components/lineGraph";
import PaginationComponent from "shared/components/pagination";
import RangeDatePicker from "shared/components/rangeDatePicker";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import useWindowSize from "shared/customHooks/windowSize";
import { routeConstant } from "shared/routes/routesConstant";
import {
  plans_headers,
  top_ups_headers,
  custom_plan_headers,
} from "./constants";
import styles from "./style.module.scss";

const tabs = [
  {
    value: 0,
    label: "Regular Plans",
  },
  {
    value: 1,
    label: "Promotional Plans",
  },
  {
    value: 2,
    label: "Top Up Account",
  },
];

const school_tabs = [
  {
    value: 0,
    label: "School Custom Plans",
  },
];

function PurchasedPlansHistory() {
  const params = useParams();
  const role: any = params?.role;
  const screenWidth = useWindowSize();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [activeTab, setActiveTab] = useState<any>(0);
  const [activePage, setActivePage] = useState<number>(1);
  const [tabHeaders, setTabHeader] = useState<any>(tabs);
  const [headers, setHeaders] = useState<any>(
    role === "schools" ? custom_plan_headers : plans_headers
  );
  const [openDetail, setOpenDetail] = useState<boolean>(false);

  useEffect(() => {
    if (role === "schools") {
      setTabHeader(school_tabs);
    }
    // eslint-disable-next-line
  }, []);

  useBreadcrumbs(
    {
      title: `${
        role.charAt(0).toUpperCase() + role.slice(1)
      } Subscriptions History`,
      path: routeConstant.purchasedPlansHistory.path?.replace(":role", role),
    },
    true
  );

  const handleChange = (event: any, newValue: number) => {
    setActiveTab(newValue);

    if (newValue === 2) {
      setHeaders(top_ups_headers);
    } else {
      setHeaders(plans_headers);
    }
  };

  let plans = [
    {
      label: "3 Months Plan",
      discounted: false,
      status: 1,
      phone: "030100201211",
      price: "12000",
      coins: "400",
      purchased: 8,
    },
    {
      label: "Monthly Plan",
      discounted: false,
      status: 2,
      phone: "030100322312",
      price: "4000",
      coins: "400",
      purchased: 12,
    },
    {
      label: "6 Months Plan",
      discounted: true,
      status: 3,
      phone: "030100322212",
      price: "24000",
      coins: "400",
      purchased: 20,
    },
    {
      label: "Annual Plan",
      discounted: false,
      status: 1,
      phone: "030100322212",
      price: "48000",
      coins: "400",
      purchased: 19,
    },
    {
      label: "9 Months Plan",
      discounted: false,
      status: 2,
      phone: "030100322212",
      price: "36000",
      coins: "400",
      purchased: 14,
    },
  ];

  let top_ups = [
    {
      label: "3 Months Plan",
      discounted: false,
      status: 1,
      phone: "030100201211",
      price: "12000",
      coins: "400",
      purchased: 8,
      amount: 100,
    },
    {
      label: "Monthly Plan",
      discounted: false,
      status: 2,
      phone: "030100322312",
      price: "4000",
      coins: "400",
      purchased: 12,
      amount: 400,
    },
    {
      label: "6 Months Plan",
      discounted: true,
      status: 3,
      phone: "030100322212",
      price: "24000",
      coins: "400",
      purchased: 20,
      amount: 200,
    },
    {
      label: "Annual Plan",
      discounted: false,
      status: 1,
      phone: "030100322212",
      price: "48000",
      coins: "400",
      purchased: 19,
      amount: 100,
    },
    {
      label: "9 Months Plan",
      discounted: false,
      status: 2,
      phone: "030100322212",
      price: "36000",
      coins: "400",
      purchased: 14,
      amount: 300,
    },
  ];

  let schools = [
    {
      label: "3 Months Plan",
      status: 1,
      phone: "030100201211",
      price: "12000",
      coins: "400",
      purchased: 8,
      amount: 100,
    },
    {
      label: "Monthly Plan",
      discounted: false,
      status: 2,
      phone: "030100322312",
      price: "4000",
      coins: "400",
      purchased: 12,
      amount: 400,
    },
    {
      label: "6 Months Plan",
      discounted: true,
      status: 3,
      phone: "030100322212",
      price: "24000",
      coins: "400",
      purchased: 20,
      amount: 200,
    },
    {
      label: "Annual Plan",
      discounted: false,
      status: 1,
      phone: "030100322212",
      price: "48000",
      coins: "400",
      purchased: 19,
      amount: 100,
    },
    {
      label: "9 Months Plan",
      discounted: false,
      status: 2,
      phone: "030100322212",
      price: "36000",
      coins: "400",
      purchased: 14,
      amount: 300,
    },
  ];

  let dataSetsForGraphs = [
    {
      label: "Monthly Plan",
      data: [
        "10","15","20","25","30","35","40","45","50","55","60","100",
        "200","300","400","500","600","700","800","900","750","650",
        "550","450","350","250","150","50",
      ],
      borderColor: "#9A469B",
      backgroundColor: "#9A469B",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#9A469B",
      pointHoverBorderColor: "#FFFFFF",
    },
    {
      label: "Annual Plan",
      data: [
        "5","10","15","20","30","40","50","60","70","80","100","780",
        "300","800","500","600","400","800","450","950","800","700",
        "600","500","400","300","200","100",
      ],
      borderColor: "#EF437B",
      backgroundColor: "#EF437B",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#EF437B",
      pointHoverBorderColor: "#FFFFFF",
    },
    {
      label: "3 Months Plan",
      data: [
        "8","16","24","32","40","48","56","64","72","400","100","250",
        "800","550","700","850","500","880","920","900","980","800",
        "700","600","500","400","300","200",
      ],
      borderColor: "#1897A6",
      backgroundColor: "#1897A6",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#1897A6",
      pointHoverBorderColor: "#FFFFFF",
    },
  ];

  const planStatus = {
    expired: 1,
    active: 2,
    deactive: 3,
  };

  return (
    <div className={styles.mainContainer}>
      <Box className={styles.headingContainer}>
        <div>
          <span className={styles.componentHeading}>
            {role === "schools"
              ? "Plans for Schools"
              : `Most Purchased Plans by ${
                  role === "kids"
                    ? " Kids"
                    : role === "parents"
                    ? " Parents"
                    : ""
                }`}
          </span>
        </div>
        <div>
          <div className={styles.dateContainer}>
            <RangeDatePicker
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              doubleLabel={true}
            />
          </div>
        </div>
      </Box>

      <div className={styles.componentContainer}>
        <Box className={styles.boxContainer}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            className={styles.tab}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{
              style: {
                backgroundColor: "black",
              },
            }}
            sx={{ background: "white", padding: "0px 14px" }}
          >
            {tabHeaders?.map((item: any, index: any) => {
              return (
                <Tab
                  key={index}
                  label={
                    <div
                      className={classNames(
                        styles.tabs,
                        activeTab === item?.value && styles.active
                      )}
                    >
                      <label className={styles.tabLabel}>{item?.label}</label>
                    </div>
                  }
                  sx={{ padding: "0px" }}
                />
              );
            })}
          </Tabs>

          <div className={styles.separator} />
        </Box>

        <div className={styles.graphFilterContainer}>
          <FilterMenu />
        </div>
        <div className={styles.graphContainer}>
          <MultiAxisLineChart
            datasets={dataSetsForGraphs}
            legend={false}
            canvasStyle={styles.canvas}
            labels={[
              "1","2","3","4","5","6","7","8","9","10","11","12","13","14",
              "15","16","17","18","19","20","21","22","23","24","25","26","27","28",
            ]}
          />
        </div>

        <div className={styles.mainContainer}>
          <div className={styles.mainTableContainer}>
            <Box className={styles.topHeadingContainer}>
              <div>
                <div className={styles.heading}>
                  {role === "schools"
                    ? "Custom Plans of Schools"
                    : `Most Plans purchased by ${
                        role === "kids"
                          ? " Kids"
                          : role === "parents"
                          ? " Parents"
                          : ""
                      }`}
                </div>
                <div className={styles.subHeading}>
                  Plans are list by most sales
                </div>
              </div>
              <div className={styles.btnContainer}>
                <button className={styles.filterBtn}>
                  <Icons.FilterIcon /> Filter
                </button>
              </div>
            </Box>

            <TableContainer
              component={Paper}
              className={styles.tableContainer}
              sx={screenWidth > 990 ? { width: `${screenWidth - 330}px` } : {}}
              id="table-view-dashboard"
            >
              <Table>
                <TableHead className={styles.tableHead}>
                  <TableRow>
                    {headers?.map((item: any, index: any) => (
                      <TableCell key={index}>{item}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody className={styles.tableBody}>
                  {role === "schools"
                    ? schools?.map((item: any, index: number, arr: any[]) => (
                        <TableRow
                          key={index}
                          className={classNames(
                            index + 1 === arr?.length && styles.noBorder
                          )}
                        >
                          <TableCell
                            sx={{ display: "flex", gap: "10px", alignItems: "center" }}
                          >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                              <img
                                src={Images.UserPlaceholderImage}
                                alt="profile_picture"
                                className={styles.profilepic}
                              />
                              <div style={{ display: "flex", flexDirection: "column" }}>
                                <label>School Name</label>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell>Rs. {item?.amount}</TableCell>
                          <TableCell>{item?.coins}</TableCell>
                          <TableCell>{item?.label}</TableCell>
                          <TableCell className={classNames(styles.statusCell)}>
                            <label
                              className={
                                item?.status === planStatus.active
                                  ? styles.approved
                                  : item?.status === planStatus.deactive
                                  ? styles.rejected
                                  : item?.status === planStatus.expired
                                  ? styles.neutral
                                  : ""
                              }
                            >
                              {item?.status === planStatus.active
                                ? "Active"
                                : item?.status === planStatus.deactive
                                ? "Deactive"
                                : item?.status === planStatus.expired
                                ? "Expired"
                                : ""}
                            </label>
                          </TableCell>
                          <TableCell>
                            <div className={styles.actionContainer}>
                              <div onClick={() => setOpenDetail(true)}>
                                <Tooltip arrow title="View Discounted Detail">
                                  <Icons.EyeIcon />
                                </Tooltip>
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    : activeTab === 2
                    ? top_ups?.map((item: any, index: number, arr: any[]) => (
                        <TableRow
                          key={index}
                          className={classNames(
                            index + 1 === arr?.length && styles.noBorder
                          )}
                        >
                          <TableCell>Rs. {item?.amount}</TableCell>
                          <TableCell>{item?.coins}</TableCell>
                          <TableCell>{item?.purchased} Times</TableCell>
                          <TableCell>
                            {Number(item?.coins) * Number(item?.purchased)}
                          </TableCell>
                          <TableCell className={styles.biggerCell}>
                            Rs. {Number(item?.coins) * Number(item?.amount)}
                          </TableCell>
                          <TableCell className={classNames(styles.statusCell)}>
                            <label
                              className={
                                item?.status === planStatus.active
                                  ? styles.approved
                                  : item?.status === planStatus.deactive
                                  ? styles.rejected
                                  : item?.status === planStatus.expired
                                  ? styles.neutral
                                  : ""
                              }
                            >
                              {item?.status === planStatus.active
                                ? "Active"
                                : item?.status === planStatus.deactive
                                ? "Deactive"
                                : item?.status === planStatus.expired
                                ? "Expired"
                                : ""}
                            </label>
                          </TableCell>
                        </TableRow>
                      ))
                    : plans?.map((item: any, index: number, arr: any[]) => (
                        <TableRow
                          key={index}
                          className={classNames(
                            index + 1 === arr?.length && styles.noBorder
                          )}
                        >
                          <TableCell
                            sx={{ display: "flex", gap: "10px", alignItems: "center" }}
                            className={styles.biggerCell}
                          >
                            <Icons.PlanIcon />
                            <label>{item?.label}</label>
                          </TableCell>
                          <TableCell>{item?.discounted ? "Yes" : "No"}</TableCell>
                          <TableCell>Rs {item?.price}</TableCell>
                          <TableCell>{item?.coins}</TableCell>
                          <TableCell>{item?.purchased} Times</TableCell>
                          <TableCell>
                            {Number(item?.coins) * Number(item?.purchased)}
                          </TableCell>
                          <TableCell className={styles.biggerCell}>
                            Rs. {Number(item?.price) * Number(item?.purchased)}
                          </TableCell>
                          <TableCell className={classNames(styles.statusCell)}>
                            <label
                              className={
                                item?.status === planStatus.active
                                  ? styles.approved
                                  : item?.status === planStatus.deactive
                                  ? styles.rejected
                                  : item?.status === planStatus.expired
                                  ? styles.neutral
                                  : ""
                              }
                            >
                              {item?.status === planStatus.active
                                ? "Active"
                                : item?.status === planStatus.deactive
                                ? "Deactive"
                                : item?.status === planStatus.expired
                                ? "Expired"
                                : ""}
                            </label>
                          </TableCell>
                          <TableCell>
                            <div className={styles.actionContainer}>
                              <div onClick={() => setOpenDetail(true)}>
                                <Tooltip arrow title="View Discounted Detail">
                                  <Icons.EyeIcon />
                                </Tooltip>
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
            <PaginationComponent
              totalPages={"1"}
              activePage={activePage}
              setActivePage={setActivePage}
            />
          </div>
        </div>
      </div>
      <ViewDetails
        open={openDetail}
        handleClose={() => setOpenDetail(false)}
        activeTab={activeTab}
        role={role}
      />
    </div>
  );
}

export default PurchasedPlansHistory;

function FilterMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        style={{
          background: "transparent",
          border: "none",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        className={styles.filterBtn}
      >
        <span
          className={classNames(styles.filterLabel)}
          style={{ textTransform: "none" }}
        >
          Apply Filter
        </span>
        <KeyboardArrowDownIcon sx={{ color: "#9a469b" }} />
      </button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        PaperProps={{
          sx: {
            boxShadow: "none",
            border: "1px solid #e2e2e2",
            padding: "0px 10px",
            background: "white",
          },
        }}
      >
        <MenuItem onClick={handleClose}>Filter 1</MenuItem>
        <MenuItem onClick={handleClose}>Filter 2</MenuItem>
        <MenuItem onClick={handleClose}>Filter 3</MenuItem>
      </Menu>
    </div>
  );
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ViewDetails({ open, handleClose, activeTab, role }: any) {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        PaperProps={{
          sx: {
            padding: "32px",
            maxWidth: "712px",
            width: "100%",
            justifyContent: "center",
            borderRadius: "10px",
          },
        }}
      >
        <DialogContent sx={{ padding: "0px" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <label
              className={styles.componentHeading}
              style={{ marginBottom: "20px" }}
            >
              Plan Details
            </label>
            <Icons.CrossIcon
              style={{ cursor: "pointer" }}
              onClick={() => handleClose()}
            />
          </div>
          {role !== "schools" && (
            <div className={styles.twoColumnsGrid}>
              {activeTab === 0 ? (
                <>
                  <div className={styles.gridCell}>
                    <span>Discounted Title</span>
                    <span>Title</span>
                  </div>
                  <div className={styles.gridCell}>
                    <span>Discounted Amount</span>
                    <span>Rs. 400</span>
                  </div>
                  <div className={styles.gridCell}>
                    <span>Discount Start Date</span>
                    <span>{moment(new Date()).format("MMM DD, YYYY")}</span>
                  </div>
                  <div className={styles.gridCell}>
                    <span>Discount End Date</span>
                    <span>{moment(new Date()).format("MMM DD, YYYY")}</span>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.gridCell}>
                    <span>Promotion Title</span>
                    <span>Title</span>
                  </div>
                  <div className={styles.gridCell}>
                    <span>Promotion Start Date</span>
                    <span>{moment(new Date()).format("MMM DD, YYYY")}</span>
                  </div>
                  <div className={styles.gridCell}>
                    <span>Promotion End Date</span>
                    <span>{moment(new Date()).format("MMM DD, YYYY")}</span>
                  </div>
                </>
              )}
            </div>
          )}

          <div className={styles.planCard}>
            <div className={styles.planTitle}>Plan Name</div>
            <div className={styles.singleBenefit}>
              <Icons.TickIcon /> Benefit 1
            </div>
            <div className={styles.singleBenefit}>
              <Icons.TickIcon /> Benefit 2
            </div>
            <div className={styles.singleBenefit}>
              <Icons.TickIcon /> Benefit 3
            </div>
            <div className={styles.singleBenefit}>
              <Icons.TickIcon /> Benefit 4
            </div>
            <div className={styles.singleBenefit}>
              <Icons.TickIcon /> Benefit 5
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
